module.exports = __webpack_public_path__ + "static/media/certCDL.a11702fc.pdf";